import PropTypes from 'prop-types'
import React from 'react'

import StarRating from '../../../components/starRating'
import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import TrendingSash from './common/trendingSash'
import MagnifierConfigurator from '../../../components/magnifier/configurator'
import Overlay from '../../../components/overlay'
import ItemActions from './common/itemActions'
import formatPrice from '../../../../common/utils/formatPrice'
import itemSmallPreviewUrl from '../../../../common/utils/itemSmallPreviewUrl'

const ItemCardGridDefault = ({
  item,
  onAddToFavourites,
  rank,
  onAddToCollections,
  onItemLinkClick = () => {},
  onAddToCart = () => {}
}) => {
  const salesLabel = item.number_of_sales === 1 ? 'Sale' : 'Sales'
  const firstVisibleImagesCount = 10
  return (
    <div>
      <div className="product-grid__inside">
        <div>
          <div className="item-thumbnail">
            <Overlay position="side" content={MagnifierConfigurator({ item })}>
              <div className="item-thumbnail__image">
                {item.trending && <TrendingSash />}
                <a
                  href={`${item.url}?s_rank=${rank}`}
                  onClick={onItemLinkClick}
                  className="item-thumbnail__link"
                  aria-label={item.name}
                >
                  <EnhancedLazyLoad
                    height="100%"
                    once
                    offset={200}
                    disabled={rank <= firstVisibleImagesCount}
                  >
                    <img
                      alt={item.name}
                      className="preload no_preview landscape-image-magnifier"
                      src={itemSmallPreviewUrl(item)}
                      title={item.name}
                    />
                  </EnhancedLazyLoad>
                </a>

                {item.previews.live_site ? (
                  <div className="item-thumbnail__preview">
                    <a
                      href={item.previews.live_site.url}
                      target="_blank"
                      className="item-thumbnail__preview-link"
                    >
                      Live preview
                    </a>
                  </div>
                ) : null}
              </div>
            </Overlay>
          </div>
        </div>

        <div className="product-grid__item-thumbnail-actions">
          <div className="item-thumbnail-actions -width-full">
            <ul className="item-thumbnail-actions__list">
              <ItemActions
                item={item}
                onAddToFavourites={onAddToFavourites}
                onAddToCollections={onAddToCollections}
                onAddToCart={onAddToCart}
              />
            </ul>
          </div>
        </div>

        <h3 className="product-grid__heading fds-u-text-truncate">
          <a
            className="fds-c-text-link -color-inherit -decoration-reversed"
            href={`${item.url}?s_rank=${rank}`}
            onClick={onItemLinkClick}
          >
            {item.name}
          </a>
        </h3>

        <div className="product-grid__rating">
          {item.rating.rating ? (
            <StarRating
              rating={item.rating.rating}
              className="star-rating--search"
            />
          ) : null}
        </div>

        <footer className="product-grid__footer">
          <p className="fds-c-text-body -size-xs fds-u-m0">
            {item.number_of_sales} {salesLabel}{' '}
            <span className="product-grid__price">
              ${formatPrice(item.price_cents)}
            </span>
          </p>
        </footer>
      </div>
    </div>
  )
}

ItemCardGridDefault.propTypes = {
  item: PropTypes.object.isRequired,
  onAddToFavourites: PropTypes.func.isRequired,
  rank: PropTypes.number.isRequired,
  onItemLinkClick: PropTypes.func,
  onAddToCart: PropTypes.func
}

export default ItemCardGridDefault
